import { z } from "zod/v4";
import { EcommerceDataSchema } from "./get-ecommerce-data";

// ViewEcommerceItemEvent
export const ViewEcommerceItemEventSchema = z.object({
  eventName: z.literal("view_item"),
  ecommerce: EcommerceDataSchema.pick({
    currency: true,
    items: true,
    value: true,
  }),
});

// ViewEcommerceItemListEvent
export const ViewEcommerceItemListEventSchema = z.object({
  eventName: z.literal("view_item_list"),
  ecommerce: EcommerceDataSchema.pick({ currency: true, items: true }).extend({
    item_list_id: z.string(),
    item_list_name: z.string(),
  }),
});

// ViewPromotionEvent
export const ViewPromotionEventSchema = z.object({
  eventName: z.literal("view_promotion"),
  ecommerce: EcommerceDataSchema.pick({
    items: true,
  }).extend({
    creative_name: z.string().optional(),
    creative_slot: z.string().optional(),
    promotion_id: z.string().optional(),
    promotion_name: z.string().optional(),
  }),
});

// SearchEvent
export const SearchEventSchema = z.object({
  eventName: z.literal("search"),
  search_term: z.string(),
});

// SelectContentEvent
export const SelectContentEventSchema = z.object({
  eventName: z.literal("select_content"),
  content_type: z.string().optional(),
  content_id: z.string().optional(),
});

// SelectItemEvent
export const SelectItemEventSchema = z.object({
  eventName: z.literal("select_item"),
  ecommerce: EcommerceDataSchema.pick({
    items: true,
  }).extend({
    item_list_id: z.string(),
    item_list_name: z.string(),
  }),
});

// SelectPromotionEvent
export const SelectPromotionEventSchema = z.object({
  eventName: z.literal("select_promotion"),
  ecommerce: EcommerceDataSchema.pick({
    items: true,
  }).extend({
    creative_name: z.string().optional(),
    creative_slot: z.string().optional(),
    promotion_id: z.string().optional(),
    promotion_name: z.string().optional(),
  }),
});

// AddToCartEvent
export const AddToCartEventSchema = z.object({
  eventName: z.literal("add_to_cart"),
  ecommerce: EcommerceDataSchema.pick({
    cart_id: true,
    currency: true,
    value: true,
    items: true,
    coupon: true,
  }),
});

// RemoveFromCartEvent
export const RemoveFromCartEventSchema = z.object({
  eventName: z.literal("remove_from_cart"),
  ecommerce: EcommerceDataSchema.pick({
    cart_id: true,
    currency: true,
    value: true,
    items: true,
    coupon: true,
  }),
});

// ViewCartEvent
export const ViewCartEventSchema = z.object({
  eventName: z.literal("view_cart"),
  ecommerce: EcommerceDataSchema.pick({
    cart_id: true,
    currency: true,
    value: true,
    items: true,
    coupon: true,
    coupons: true,
    discount: true,
  }),
});

// BeginCheckoutEvent
export const BeginCheckoutEventSchema = z.object({
  eventName: z.literal("begin_checkout"),
  ecommerce: EcommerceDataSchema.pick({
    currency: true,
    value: true,
    items: true,
    coupon: true,
    coupons: true,
    cart_id: true,
    shipping: true,
    tax: true,
    discount: true,
  }),
});

// AddShippingInfoEvent
export const AddShippingInfoEventSchema = z.object({
  eventName: z.literal("add_shipping_info"),
  ecommerce: EcommerceDataSchema.pick({
    currency: true,
    value: true,
    items: true,
    coupon: true,
    coupons: true,
    cart_id: true,
    shipping: true,
    tax: true,
    discount: true,
  }).extend({
    shipping_tier: z.string().optional(),
  }),
});

// AddPaymentInfoEvent
export const AddPaymentInfoEventSchema = z.object({
  eventName: z.literal("add_payment_info"),
  ecommerce: EcommerceDataSchema.pick({
    currency: true,
    value: true,
    items: true,
    coupon: true,
    coupons: true,
    cart_id: true,
    shipping: true,
    tax: true,
    discount: true,
  }).extend({
    payment_type: z.string().optional(),
  }),
});

// PurchaseEvent
export const PurchaseEventSchema = z.object({
  eventName: z.literal("purchase"),
  ecommerce: EcommerceDataSchema.extend({
    shipping: z.number().optional(),
    tax: z.number().optional(),
    transaction_id: z.string(),
  }),
});
